// extracted by mini-css-extract-plugin
export default {"tasks":"IM-z","task":"JM-z","svg":"KM-z","text":"LM-z"};